import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 34 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ num, eyebrow, title, dark = false, center = false, testid }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl`} data-testid={testid}>
    <Reveal>
      <p
        className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] ${
          center ? "justify-center" : ""
        } ${dark ? "text-white/50" : "text-slate-400"}`}
      >
        <span className="text-gold">{num}</span>
        <span className="h-px w-8 bg-gold/60" aria-hidden="true" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  </div>
);
